import {
  FC,
  MutableRefObject,
  ReactElement,
  useCallback,
  useEffect,
  useRef
} from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { EIconSize } from 'utils/constants/app/ui';
import { GlobalIcon } from 'components/GlobalIcon';
import { Option, Select } from 'newcomponents/UI/Select';
import { setCompetition } from 'store/actions/results-data';
import {
  getResultsCompetition,
  getResultsData,
  getResultsSport
} from 'store/selectors/results-data';
import './index.less';

type Props = {
  disabled?: boolean;
};

const COMPETITION_COUNT = -1;

export const CompetitionFilter: FC<Props> = ({ disabled }): ReactElement => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const resultsData = useSelector(getResultsData);
  const resultsSport = useSelector(getResultsSport);
  const resultsCompetition = useSelector(getResultsCompetition);
  const containerRef =
    useRef<HTMLDivElement>() as MutableRefObject<HTMLDivElement>;

  const handleChange = useCallback((value: number | undefined) => {
    dispatch(setCompetition(value === COMPETITION_COUNT ? undefined : value));
  }, []);

  useEffect(() => {
    handleChange(undefined);
  }, [resultsSport]);

  const results = () => {
    const resultItem = resultsData?.find(sport => sport.Id === resultsSport);

    return (
      resultItem?.Regions?.map(region =>
        region.Competitions?.map(competition => {
          return (
            <Option
              value={competition.Id}
              key={competition.Id}
              title={`${region.Name} - ${competition.Name}`}
              data-testid="result_competition_filter_option"
            >
              {region.Name} - {competition.Name}
            </Option>
          );
        })
      ) || []
    );
  };

  return (
    <div className="competitionFilter" ref={containerRef}>
      <div className="competitionFilter__label">
        {t('sportsbook.competition')}
      </div>
      <Select
        suffixIcon={
          <GlobalIcon
            lib="generic"
            name="selectArrow"
            theme="default"
            size={EIconSize._12}
          />
        }
        size="large"
        className="competitionFilter__select"
        onChange={handleChange}
        defaultValue={-1}
        value={resultsCompetition || COMPETITION_COUNT}
        disabled={disabled}
        getPopupContainer={() => containerRef.current}
        data-testid="result_competition_filter"
      >
        <Option value={-1} title={t('sportsbook.all')}>
          {t('sportsbook.all')}
        </Option>
        <>{results()}</>
      </Select>
    </div>
  );
};
